export enum DiscountCodeStates {
    Valid = 'VALID',
    Invalid = 'INVALID',
    Expired = 'EXPIRED',
    LimitReached = 'LIMIT_REACHED',
    ValidFuture = 'VALID_FUTURE',
}
